/**
 * @param {object} error - takes an exception and logs to Sentry or the console in development
 * @param {warn} warn - if true then it will just be warned to the console
 * @desc logger is designed for logging errors. It will accept an argument of any type and create a stacktrace containing a reference to the callee.
 * @TODO Migrate this functionality to a logging module that handles different levels of logs
 */
const logger = (error, warn = false) => {
    if (warn) {
        console.warn(error); //eslint-disable-line
        return;
    }
    if (process && process.env && process.env.NODE_ENV !== 'production') {
        try {
            throw error; //This looks strange to re-throw an error, but sometimes the logger doesn't receive an instance of an error and you want an error containing a stack trace of the callee.
        } catch (e) {
            console.error(e); //eslint-disable-line
        }
        return;
    }

    if (window && window.Raven) {
        if (error instanceof Error) {
            Raven.captureException(error);
        } else {
            try {
                throw new Error(error);
            } catch (e) {
                Raven.captureException(e);
            }
        }
        console.error(error); //eslint-disable-line
    } else {
        console.error(error); //eslint-disable-line
    }
};

export default logger;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/packages/logger.js